// Consentement cookies/stockage local — voir CookieConsentBanner.tsx. OLTODO n'utilise
// aujourd'hui que du stockage essentiel (session, langue, voir utils/api.ts) : aucun cookie
// publicitaire ni analytique n'est posé, mais l'infrastructure de consentement est mise en place
// dès maintenant pour pouvoir gouverner un futur script d'analyse sans jamais le charger avant
// un vrai accord de l'utilisateur.
export type CookieConsent = { essential: true; analytics: boolean; decidedAt: string };

const KEY = "oltodo_cookie_consent";

export function getCookieConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(analytics: boolean): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ essential: true, analytics, decidedAt: new Date().toISOString() }));
  } catch {}
}

// À appeler avant de charger tout futur script d'analyse/publicité — reste false tant qu'aucun
// choix n'a été fait, jamais un chargement "par défaut" avant consentement explicite.
export function hasAnalyticsConsent(): boolean {
  return getCookieConsent()?.analytics === true;
}
